import axios from './../http'

function query(data) {
    return axios.post('/sys/userPartner/query', data);
}

export default {
    query
}